export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20background%20with%20warm%20amber%20spotlight%20glow%2C%20abstract%20film%20strip%20texture%2C%20soft%20bokeh%20lights%2C%20dramatic%20atmosphere%2C%20movie%20projector%20beam%20effect%2C%20rich%20dark%20red%20and%20gold%20tones%2C%20luxurious%20velvet%20curtain%20vibe%2C%20cinematic%20wide%20shot%20composition%20with%20deep%20shadows%20and%20warm%20highlights&width=1440&height=900&seq=hero-bg-cinema&orientation=landscape"
          alt="影院背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="section-container relative z-10 w-full py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-5">
              <i className="ri-fire-fill text-primary-500 text-sm"></i>
              <span className="text-primary-500 text-xs font-medium whitespace-nowrap">每日更新 · 海量片库</span>
            </div>

            <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-3">
              68影院 · 你的私人电影大全
            </h1>

            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              影院品质，在家即享。聚合全网高清电影资源，每日更新片库，从经典老片到院线新作一网打尽。无需下载，打开即播，流畅不卡顿 —
              让每一次观影都成为纯粹的享受。
            </p>

            <p className="text-sm text-white/50 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              本周已收录
              <strong className="text-accent-400 font-semibold"> 32部新片</strong>
              ，热门电影排行榜实时更新中；覆盖
              <strong className="text-accent-400 font-semibold"> 动作、悬疑、喜剧、科幻、爱情 </strong>
              等全类型；片库总量突破
              <strong className="text-accent-400 font-semibold"> 50,000+ 部</strong>
              ，高清画质保证。
            </p>

            <div className="flex items-center gap-3 justify-center lg:justify-start flex-wrap">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                热门排行
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-medium rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-fill"></i>
                分类找片
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[320px] md:max-w-[400px] lg:max-w-[480px]">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-black/40 aspect-[3/4] max-h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20collage%20design%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20abstract%20film%20elements%20floating%2C%20dramatic%20lighting%2C%20movie%20clapperboard%20silhouette%2C%20film%20reel%20artwork%2C%20artistic%20composition%2C%20luxurious%20theater%20aesthetic%2C%20no%20text%2C%20clean%20graphic%20design%20style&width=600&height=800&seq=hero-poster-cinema&orientation=portrait"
                alt="68影院主视觉 - 电影艺术海报"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}